export class CampiIntestazione {
    tipoPratica: string;
    posizionePratica: string;
    definita: boolean;
    archiviata: boolean;
    capofila: boolean;
    riunita: boolean;
    dataArchiviazione: Date;
    dataDefinizione: Date;
    contropartePrimaria: string;
    oggetto: string;
    societa: string;
    materia: string;
    testoDiEvidenza: string;
    dataAperturaPratica: Date;
    materiaId: string;
    oggettoId: string;
    soggetto?: string;
    dataApertura?: Date;
    alerts: string[];

    numeroSinistro: string;
}
